import { IntlProvider } from 'react-intl';
import { SkeletonLoader } from '../../components';
import { useLocalizationQuery } from '../../queries';
import { jsx as _jsx } from "react/jsx-runtime";
export var I18nContainer = function I18nContainer(_ref) {
  var children = _ref.children;
  var _useLocalizationQuery = useLocalizationQuery(),
    localizationData = _useLocalizationQuery.data;
  if (!localizationData) {
    return /*#__PURE__*/_jsx(SkeletonLoader, {});
  }
  var locale = localizationData.locale,
    translations = localizationData.translations;
  return /*#__PURE__*/_jsx(IntlProvider, {
    locale: locale,
    messages: translations,
    children: children
  });
};